import { APP_HOMEPAGE_ROUTE } from "../config/constant";

/** Function to give the current page for the user based on the onboarding status
 * @param {Object} navigationAccesses - navigationAccesses object from the user
 * @returns {String} current page for the user
 */
export const verifyUserIsOnboarding = navigationAccesses => {
    //TODO: RENAME THIS FUNCTION
    let onboardingRoute = APP_HOMEPAGE_ROUTE;

    if (!navigationAccesses) return undefined;

    const organizationStatus = navigationAccesses?.organization?.status;

    const onboardingOrganizationPanel =
        navigationAccesses?.organization?.navigationPanel && navigationAccesses?.organization?.createModeOnly;

    const onboardingCompanyPanel =
        navigationAccesses?.companies?.navigationPanel && navigationAccesses?.companies?.createModeOnly;

    const onboardingPOSPanel = navigationAccesses?.POS?.navigationPanel && navigationAccesses?.POS?.createModeOnly;

    const completedOnboarding = navigationAccesses?.POS?.navigationPanel && !navigationAccesses?.POS?.createModeOnly;

    const homepageError =
        !onboardingOrganizationPanel && !onboardingCompanyPanel && !onboardingPOSPanel && !completedOnboarding;

    if (homepageError) {
        localStorage.clear();
        console.error("Homepage Error: No navigation panel is enabled");
        onboardingRoute = "/login";
        onboardingRoute = APP_HOMEPAGE_ROUTE;
    } else if (onboardingOrganizationPanel) {
        onboardingRoute = "/account/create";
    } else if (onboardingCompanyPanel) {
        onboardingRoute = "/companies/create";
    } else if (onboardingPOSPanel) {
        onboardingRoute = "/POS/create";
    } else if (completedOnboarding || organizationStatus === "Active") {
        onboardingRoute = APP_HOMEPAGE_ROUTE;
    }

    //console.log("onboardingRoute", onboardingRoute);
    return onboardingRoute;
};

/** Function to check if user has completed onboarding
 * @param {Object} navigationAccesses - navigationAccesses object from the user
 * @returns {Boolean} true if user has completed onboarding
 */
export const hasUserCompletedOnboarding = navigations => {
    const nav = navigations?.navigationAccesses ?? navigations;

    const page = verifyUserIsOnboarding(nav);
    return page === APP_HOMEPAGE_ROUTE;
};

/** Function to check if user has access to a specific section while onboarding
 * @param {Object} navigations - navigationAccesses object from the user
 * @param {String} section - section to check access for
 * @param {Boolean} accessWithoutCreateMode - check access without create mode
 * @returns {Boolean} true if user has access to the section
 */
export const hasNavigationAccess = (navigations, section, accessWithoutCreateMode = true) => {
    const nav = navigations?.navigationAccesses ?? navigations;
    if (!nav) return false;

    /*const organizationStatus = nav.organization?.status;
    const currentOnboardingRoute = verifyUserIsOnboarding(navigations);
    if (
        organizationStatus === "Active" &&
        currentOnboardingRoute !== "/login" &&
        currentOnboardingRoute !== "/billing" &&
        currentOnboardingRoute !== "/account/create" &&
        currentOnboardingRoute !== "/companies/create" &&
        currentOnboardingRoute !== "/brands/create"
    )
        return true;*/

    switch (section) {
        case "dashboard":
            if (!accessWithoutCreateMode) return nav?.dashboard?.navigationPanel;
            return nav?.dashboard?.navigationPanel && !nav?.dashboard?.createModeOnly;
        case "supplierOrders":
            if (!accessWithoutCreateMode) return nav?.supplierOrders?.navigationPanel;
            return nav?.supplierOrders?.navigationPanel && !nav?.supplierOrders?.createModeOnly;
        case "customerOrders":
            if (!accessWithoutCreateMode) return nav?.customerOrders?.navigationPanel;
            return nav?.customerOrders?.navigationPanel && !nav?.customerOrders?.createModeOnly;
        case "prices":
            if (!accessWithoutCreateMode) return nav?.prices?.navigationPanel;
            return nav?.prices?.navigationPanel && !nav?.prices?.createModeOnly;
        case "stock":
            if (!accessWithoutCreateMode) return nav?.stock?.navigationPanel;
            return nav?.stock?.navigationPanel && !nav?.stock?.createModeOnly;
        case "products":
            if (!accessWithoutCreateMode) return nav?.products?.navigationPanel;
            return nav?.products?.navigationPanel && !nav?.products?.createModeOnly;
        case "stores":
            if (!accessWithoutCreateMode) return nav?.stores?.navigationPanel;
            return nav?.stores?.navigationPanel && !nav?.stores?.createModeOnly;
        case "POS":
            if (!accessWithoutCreateMode) return nav?.POS?.navigationPanel;
            return nav?.POS?.navigationPanel && !nav?.POS?.createModeOnly;
        case "APIs":
            if (!accessWithoutCreateMode) return nav?.APIs?.navigationPanel;
            return nav?.APIs?.navigationPanel && !nav?.APIs?.createModeOnly;
        case "companies":
            if (!accessWithoutCreateMode) return nav?.companies?.navigationPanel;
            return nav?.companies?.navigationPanel && !nav?.companies?.createModeOnly;
        case "organization":
            if (!accessWithoutCreateMode) return nav?.organization?.navigationPanel;
            return nav?.organization?.navigationPanel && !nav?.organization?.createModeOnly;
        case "users":
            return true;
        default: {
            console.error("Invalid navigation access", section);
            return false;
        }
    }
};

export const userIsOnBoardingInPage = (navigations, section) => {
    const nav = navigations?.navigationAccesses ?? navigations;
    if (!nav) return false;

    switch (section) {
        case "companies":
            return nav?.companies?.createModeOnly;
        case "account":
        case "organization":
            return nav?.organization?.createModeOnly;
        case "POS":
            return nav?.POS?.createModeOnly;
        default:
            return false;
    }
};

export const getAllUnlockedNavigations = navigationAccesses => {
    const updatedNavigations = {
        ...navigationAccesses,
        dashboard: { navigationPanel: false, createModeOnly: false },
        supplierOrders: { navigationPanel: true, createModeOnly: false },
        customerOrders: { navigationPanel: true, createModeOnly: false },
        prices: { navigationPanel: true, createModeOnly: false },
        stock: { navigationPanel: true, createModeOnly: false },
        products: { navigationPanel: true, createModeOnly: false },
        stores: { navigationPanel: true, createModeOnly: false },
        POS: { navigationPanel: true, createModeOnly: false },
        companies: { navigationPanel: true, createModeOnly: false },
        organization: { navigationPanel: true, createModeOnly: false }
    };

    return updatedNavigations;
};
